import React, { useContext } from 'react';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import useIntl from '@afosto/utils-react/intl/useIntl';
import translations from './translations';
import HandlingListContext from '../../../../components/HandlingListContext';
import Property from '@afosto/app-components-react/Property';
import { boolean } from '@afosto/app-components-react/DataGrid/formatters';

const HandlingListStatusSection = () => {
  const intl = useIntl();
  const { handlingList = {} } = useContext(HandlingListContext);

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <Property
          label={intl.formatMessage(translations.properties.isOutbound)}
          value={boolean(handlingList?.is_outbound)}
        />
        <Property
          label={intl.formatMessage(translations.properties.isInProgress)}
          value={boolean(handlingList?.is_in_progress)}
        />
        <Property
          label={intl.formatMessage(translations.properties.isOnHold)}
          value={boolean(handlingList?.is_on_hold)}
        />
        <Property
          label={intl.formatMessage(translations.properties.isServiced)}
          value={boolean(handlingList?.is_serviced)}
        />
        <Property
          label={intl.formatMessage(translations.properties.isFinished)}
          value={boolean(handlingList?.is_finished)}
        />
      </CardContent>
    </Card>
  );
};

export default HandlingListStatusSection;
